<style>
  #dialog_container {
    box-sizing: border-box;
    width: min(560px, calc(100vw - 32px));
    max-height: calc(100dvh - 32px);
    overflow: auto;
    padding: var(--tl4k-spacing-xl);
    border: 1px solid var(--tl4k-outline-variant);
    border-radius: var(--tl4k-border-radius-lg);
    background: var(--tl4k-surface-default);
    color: var(--tl4k-neutral-800);
    font-family: var(--tl4k-font-family-body);
    font-size: var(--tl4k-font-size-small);
    line-height: 1.5;
  }

  #sticker_hint { margin-top: 0; }
  #sticker_note { color: var(--tl4k-neutral-600); }
  #sticker_error { color: var(--tl4k-error); }
  [hidden] { display: none !important; }
  #sticker_preview_wrap {
    position: relative;
    overflow: auto;
    border: 1px solid var(--tl4k-outline-variant);
    border-radius: var(--tl4k-border-radius-md);
    background: repeating-conic-gradient(var(--tl4k-surface-default) 0% 25%, var(--tl4k-surface-neutral) 0% 50%) 0 / 16px 16px;
  }
  #sticker_preview { display: block; touch-action: none; }
  #sticker_eraser_cursor {
    position: absolute;
    border: 2px dashed var(--tl4k-error);
    border-radius: 50%;
    pointer-events: none;
    display: none;
    transform: translate(-50%, -50%);
  }
  .sticker_row, #sticker_brush_wrap:not([hidden]), #sticker_wand_wrap:not([hidden]), #dialog_buttons {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--tl4k-spacing-sm);
    margin-top: var(--tl4k-spacing-md);
  }
  .sticker_row > label { flex: 1 1 180px; }
  #dialog_buttons { justify-content: flex-end; margin-top: var(--tl4k-spacing-xl); }

  button, input, select {
    box-sizing: border-box;
    max-width: 100%;
    min-height: 44px;
    font: inherit;
    color: inherit;
    accent-color: var(--tl4k-primary-500);
  }
  button, input[type="number"], select {
    padding: var(--tl4k-spacing-sm);
    border: 1px solid var(--tl4k-outline);
    border-radius: var(--tl4k-border-radius-md);
    background: var(--tl4k-surface-default);
  }
  input[type="number"] { width: 90px; }
  input[type="range"] { flex: 1 1 120px; min-width: 0; }
  input[type="checkbox"] { min-height: auto; }
  output { min-width: 3ch; text-align: right; }
  button { cursor: pointer; }
  button:hover { background: var(--tl4k-surface-neutral); }
  #sticker_ok { background: var(--tl4k-primary-500); color: var(--tl4k-surface-default); border-color: var(--tl4k-primary-500); }
  #sticker_ok:hover { background: var(--tl4k-primary-700); }
  :is(button, input, select):focus-visible { outline: 2px solid var(--tl4k-focus); outline-offset: 2px; }
</style>
<elix-dialog id="sticker_box" aria-label="sticker cutline" closed>
  <div class="overlay"></div>
  <div id="dialog_container">
    <div id="dialog_content">
      <p id="sticker_hint"></p>
      <div id="sticker_preview_wrap">
        <canvas id="sticker_preview"></canvas>
      </div>
      <div class="sticker_row">
        <label for="sticker_threshold" id="sticker_threshold_label"></label>
        <input type="range" id="sticker_threshold" min="0" max="255" step="1" value="128">
        <output id="sticker_threshold_value">128</output>
      </div>
      <div class="sticker_row">
        <label for="sticker_tolerance" id="sticker_tolerance_label"></label>
        <input type="range" id="sticker_tolerance" min="0" max="10" step="0.5" value="0">
        <output id="sticker_tolerance_value">0</output>
      </div>
      <div class="sticker_row">
        <label for="sticker_offset" id="sticker_offset_label"></label>
        <input type="number" id="sticker_offset" min="-100" max="200" step="0.5" value="3">
        <select id="sticker_unit">
          <option value="px" id="sticker_unit_px"></option>
          <option value="mm" id="sticker_unit_mm"></option>
        </select>
      </div>
      <div class="sticker_row">
        <label>
          <input type="checkbox" id="sticker_erase_enable">
          <span id="sticker_erase_label"></span>
        </label>
      </div>
      <div id="sticker_edit_controls" hidden>
        <div class="sticker_row">
          <label for="sticker_tool" data-i18n="tool"></label>
          <select id="sticker_tool">
            <option value="eraser" data-i18n="eraser"></option>
            <option value="wand" data-i18n="wand"></option>
          </select>
        </div>
        <div id="sticker_brush_wrap" hidden>
          <label for="sticker_brush" id="sticker_brush_label"></label>
          <input type="range" id="sticker_brush" min="2" max="120" step="1" value="20">
          <output id="sticker_brush_value" for="sticker_brush">20</output>
        </div>
        <div id="sticker_wand_wrap" hidden>
          <label for="sticker_color_tolerance" data-i18n="color_tolerance"></label>
          <input type="range" id="sticker_color_tolerance" min="0" max="100" step="1" value="10">
          <output id="sticker_color_tolerance_value" for="sticker_color_tolerance">10</output>
          <label><input type="checkbox" id="sticker_contiguous" checked><span data-i18n="contiguous"></span></label>
        </div>
        <div class="sticker_row">
          <button type="button" id="sticker_undo" data-i18n="undo" disabled></button>
          <button type="button" id="sticker_redo" data-i18n="redo" disabled></button>
          <button type="button" id="sticker_erase_reset" disabled></button>
        </div>
      </div>
      <p id="sticker_note"></p>
      <p id="sticker_error" role="alert" aria-live="assertive" aria-atomic="true"></p>
    </div>
    <div id="dialog_buttons">
      <button id="sticker_ok"></button>
      <button id="sticker_cancel"></button>
    </div>
  </div>
</elix-dialog>
